import React from "react";
import FormGroup from "./FormGroup";
import Checkbox from "./Checkbox";

export default function CheckboxFormGroup({
  error,
  valid = !error,
  help,
  required,
  wrapperClassName,
  wrapperStyle,
  label,
  ...rest
}) {
  return (
    <FormGroup error={error} valid={valid} required={required} className={wrapperClassName} style={wrapperStyle}>
      <Checkbox label={label} required={required} {...rest} />
      {!!help && <div className="ui help">{help}</div>}
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/CheckboxFormGroup.jsx